import React from 'react'
import PropType from 'prop-types'
import cx from 'classnames'

import style from './Loader.scss'

function Loader({ className }) {
  const componentClass = cx(style.loader, { [className]: className })
  return (
    <div className={componentClass}>
      <div>
        <div />
      </div>
      <div>
        <div />
      </div>
      <div>
        <div />
      </div>
      <div>
        <div />
      </div>
    </div>
  )
}

Loader.propTypes = {
  className: PropType.string,
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Common/Loader.js